import { render, staticRenderFns } from "./MsgLeftImg.vue?vue&type=template&id=5f98dbda&scoped=true&"
import script from "./MsgLeftImg.vue?vue&type=script&lang=js&"
export * from "./MsgLeftImg.vue?vue&type=script&lang=js&"
import style0 from "./MsgLeftImg.vue?vue&type=style&index=0&id=5f98dbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f98dbda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f98dbda')) {
      api.createRecord('5f98dbda', component.options)
    } else {
      api.reload('5f98dbda', component.options)
    }
    module.hot.accept("./MsgLeftImg.vue?vue&type=template&id=5f98dbda&scoped=true&", function () {
      api.rerender('5f98dbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/MsgLeftImg.vue"
export default component.exports